/**
 * What a customer is charged for warehousing, from a date.
 *
 * `productId` null is the account-wide rate; a product id overrides it for that product alone.
 * Rates succeed one another by `effectiveFrom` - there is no end date, and a price change is a new
 * row rather than an edit, so a closed month still reproduces.
 */
export class WarehouseStorageRate {
  id: number = -1;

  accountId: number = -1;
  unitId: number = -1;
  productId: number = null;

  storageRatePerDay: number = null;
  rhdRate: number = null;
  effectiveFrom: string = '';

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
